export default __webpack_public_path__ + "static/media/urban-agent-logo@3x.4c49d5c7.png";